import axios from 'axios';
import {
  API_FORECAST_LONG_LAST_BY_POINT, API_FORECAST_LONG_LAST_BY_POINT_USER, API_FORECAST_LONG_LAST_TIME, API_FORECAST_LONG_LAST_TIME_USER,
  API_FORECAST_LONG_LAST_BY_PRESET_USER, API_FORECASTLONG_DOMAIN_PREDICTS, API_FORECASTLONG_DOMAINS_PREDICTS
} from '../../constants';

export default {
  state: {
    forecast: [],
    lastTime: null
  },
  mutations: {
    SET_FORECAST_LONG: (state, payload) => {
      state.forecast = payload;
    },
    SET_FORECAST_LONG_LAST_TIME: (state, payload) => {
      state.forecast = payload;
    },
  },
  actions: {
    FETCH_FORECAST_LONG: async (context, payload) => {
      try {
        const url = `${API_FORECAST_LONG_LAST_BY_POINT(payload.latitude, payload.longitude)}`;
        let response = await axios.get(url);
        const result = response.data.result;

        context.commit('SET_FORECAST_LONG', result);
        return result;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
    FETCH_FORECAST_LONG_USER: async (context, payload) => {
      try {
        const url = `${API_FORECAST_LONG_LAST_BY_POINT_USER(payload.userId, payload.latitude, payload.longitude)}`;
        let response = await axios.get(url);
        const result = response.data.result;

        context.commit('SET_FORECAST_LONG', result);
        return result;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
    FETCH_FORECAST_LONG_PRESET_USER: async (context, payload) => {
      try {
        const url = `${API_FORECAST_LONG_LAST_BY_PRESET_USER(payload.userId, payload.presetId)}`;
        let response = await axios.get(url);
        const result = response.data.result;

        context.commit('SET_FORECAST_LONG', result);
        return result;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
    FETCH_FORECAST_LONG_LAST_TIME: async (context) => {
      try {
        const url = `${API_FORECAST_LONG_LAST_TIME}`;
        let response = await axios.get(url);
        const result = response.data.result;
        context.commit('SET_FORECAST_LONG_LAST_TIME', result);
        return result;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
    FETCH_FORECAST_LONG_LAST_TIME_USER: async (context, payload) => {
      try {
        const url = `${API_FORECAST_LONG_LAST_TIME_USER(payload)}`;
        let response = await axios.get(url);
        const result = response.data.result;
        context.commit('SET_FORECAST_LONG_LAST_TIME', result);
        return result;
      } catch (err) {
        context.commit('PUSH_ERROR', err);
      }
    },
    FETCH_DOMAIN_PREDICTS: async (context, payload) => {
      try {
        const url = `${API_FORECASTLONG_DOMAIN_PREDICTS(payload.domainName)}`;
        const response = await axios.get(url);
        const predicts = response.data.result.predicts;
        return predicts
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return []
      }
    },
    FETCH_DOMAINS_PREDICTS: async (context) => {
      try {
        const url = `${API_FORECASTLONG_DOMAINS_PREDICTS(1000, 0)}`;
        const response = await axios.get(url);
        const predicts = response.data.result.data;
        return predicts
      } catch (err) {
        context.commit('PUSH_ERROR', err);
        return []
      }
    },
  },
  getters: {
    FORECAST_LONG: state => {
      return state.forecast;
    },
    FORECAST_LONG_LAST_TIME: state => {
      return state.lastTime;
    },
  }
}